export interface Damageable {
  health: number;
  readonly maximumHealth: number;
  dead: boolean;
  armor?: number;
}

export interface DamageResult {
  readonly applied: number;
  readonly absorbed: number;
  readonly killed: boolean;
  readonly remainingHealth: number;
}

export function applyDamage(target: Damageable, amount: number): DamageResult {
  if (target.dead || amount <= 0) {
    return { applied: 0, absorbed: 0, killed: false, remainingHealth: target.health };
  }

  const availableArmor = Math.max(0, target.armor ?? 0);
  const absorbed = Math.min(availableArmor, Math.floor(amount * 0.5));
  const applied = Math.min(target.health, Math.max(0, amount - absorbed));
  target.health -= applied;
  if (target.armor !== undefined) {
    target.armor -= absorbed;
  }
  const killed = target.health <= 0;
  if (killed) {
    target.health = 0;
    target.dead = true;
  }
  return { applied, absorbed, killed, remainingHealth: target.health };
}
